import { useEffect, useRef, useState } from "react";
import { wsUrl } from "./api";

export function useSessionSocket(sessionId, onEvent) {
  const wsRef = useRef(null);
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (!sessionId) return;
    let retry;
    let alive = true;

    const connect = () => {
      const ws = new WebSocket(wsUrl(sessionId));
      wsRef.current = ws;
      ws.onopen = () => alive && setConnected(true);
      ws.onclose = () => {
        if (!alive) return;
        setConnected(false);
        retry = setTimeout(connect, 1500);
      };
      ws.onmessage = (e) => {
        try {
          const data = JSON.parse(e.data);
          onEvent && onEvent(data);
        } catch {
          /* ignore */
        }
      };
    };
    connect();
    const ping = setInterval(() => {
      if (wsRef.current?.readyState === 1) {
        wsRef.current.send(JSON.stringify({ type: "ping" }));
      }
    }, 25000);
    return () => {
      alive = false;
      clearInterval(ping);
      clearTimeout(retry);
      wsRef.current?.close();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  return { connected };
}

export function useCountdown(startedAt, durationSeconds, status) {
  const [remaining, setRemaining] = useState(durationSeconds || 0);
  useEffect(() => {
    if (!startedAt || !durationSeconds) {
      setRemaining(durationSeconds || 0);
      return;
    }
    const start = new Date(startedAt).getTime();
    const end = start + durationSeconds * 1000;
    const tick = () => {
      if (status === "paused") return;
      const diff = Math.max(0, Math.round((end - Date.now()) / 1000));
      setRemaining(diff);
    };
    tick();
    const t = setInterval(tick, 500);
    return () => clearInterval(t);
  }, [startedAt, durationSeconds, status]);
  return remaining;
}
